import { EaseCurve } from '../lib/easing'
import { scrollTo, scrollToElement } from '../lib/helpers'

// Menu.
export default new class Menu {
	private overviewSections: HTMLAnchorElement[]
	public header: HTMLElement
	public headerElement: HTMLElement

	public get isOpen(): boolean {
		return document.body.classList.contains('menu-open')
	}

	public init() {
		this.header = document.querySelector('header')

		const onHeaderButtonClick = (event: Event) => {
			event.preventDefault()
			this.toggle()
		}

		const toggleButtons = Array.from(this.header.querySelectorAll('.header-button')) as HTMLElement[]
		for (const button of toggleButtons) {
			button.addEventListener('click', onHeaderButtonClick)
		}

		addEventListener('keyup', (event) => {
			if (event.key == 'Escape') {
				onHeaderButtonClick(event)
			}
		})

		// Section links.
		this.overviewSections = Array.from(this.header.querySelectorAll('.overview a'))
		for (const sectionLink of this.overviewSections) {
			sectionLink.addEventListener('click', (event) => {
				event.preventDefault()
				this.close()

				const elementId = sectionLink.href.split('#').pop()
				const element = document.getElementById(elementId)
				if (element) {
					scrollToElement(element, {
						duration: 1
					})
				}
			})
		}

		// Chapter links.
		const chapterLinks = Array.from(this.header.querySelectorAll('ul.chapters a')) as HTMLElement[]
		const chapterSection = document.getElementById('chapters')

		for (const chapterLink of chapterLinks) {
			chapterLink.addEventListener('click', (event) => {
				event.preventDefault()
				this.close()
				scrollToElement(chapterSection)
			})
		}

		// Clicking the logo sends you back to the top.
		if (document.body.id == 'home') {
			this.header.querySelector('a.logo')?.addEventListener('click', (event) => {
				event.preventDefault()
				scrollTo(0, 0)
				this.close()
			})
		}

		// addEventListener('load', () => this.open())
	}

	public toggle() {
		if (this.isOpen) {
			this.close()
		}
		else {
			this.open()
		}
	}

	public close() {
		document.body.classList.remove('menu-open')
		document.body.classList.add('menu-closed')
	}

	public open() {
		document.body.classList.add('menu-open')
		document.body.classList.remove('menu-closed')
		if (scrollY < innerHeight) {
			scrollTo(0, innerHeight + 1, {
				duration: 1000,
				curve: EaseCurve.Expo,
			})
		}
	}

	public setActiveSection(index: number) {
		for (let a = 0; a < this.overviewSections.length; a++) {
			this.overviewSections[a].classList.toggle('active', index === a)
		}
	}
}